import React from 'react'
import { QueryParamProvider } from 'use-query-params'
import { GatsbyAdapter } from './src/utils/gatsbyAdapter'
import Layout from './src/components/Layout'
import ThemeWrapper from './src/components/ThemeWrapper'
import ErrorBoundary from './src/components/ErrorBoundary'

export const wrapRootElement = ({ element }) => {
  return (
    <ErrorBoundary>
      <QueryParamProvider adapter={GatsbyAdapter}>
        <ThemeWrapper>{element}</ThemeWrapper>
      </QueryParamProvider>
    </ErrorBoundary>
  )
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

export const onClientEntry = () => {
  // Check if user has opted out of tracking
  const optOut = localStorage.getItem('optOut')

  // Load Paddle.js only on client-side to prevent SSR issues
  const script = document.createElement('script')
  script.src = 'https://cdn.paddle.com/paddle/paddle.js'
  script.onload = function () {
    if (window.Paddle) {
      window.Paddle.Setup({ vendor: 17524 })
    }
  }
  document.head.appendChild(script)

  // Load Snitcher Radar (first-party via green-bicycle.geticonjar.com) only if user hasn't opted out
  if (!optOut || optOut !== 'true') {
    !(function (e) {
      'use strict'
      var t = e && e.namespace
      if (t && e.profileId && e.cdn) {
        var i = window[t]
        if (
          ((i && Array.isArray(i)) || (i = window[t] = []),
          !i.initialized && !i._loaded)
        )
          if (i._loaded)
            console &&
              console.warn('[Radar] Duplicate initialization attempted')
          else {
            i._loaded = !0
            ;([
              'track',
              'page',
              'identify',
              'company',
              'group',
              'alias',
              'ready',
              'debug',
              'on',
              'off',
              'once',
              'trackClick',
              'trackSubmit',
              'trackLink',
              'trackForm',
              'pageview',
              'screen',
              'reset',
              'register',
              'setAnonymousId',
              'addSourceMiddleware',
              'addIntegrationMiddleware',
              'addDestinationMiddleware',
              'giveCookieConsent',
              'denyCookieConsent',
            ].forEach(function (e) {
              var a
              i[e] =
                ((a = e),
                function () {
                  var e = window[t]
                  if (e.initialized) return e[a].apply(e, arguments)
                  var i = [].slice.call(arguments)
                  return (i.unshift(a), e.push(i), e)
                })
            }),
              -1 === e.apiEndpoint.indexOf('http') &&
                (e.apiEndpoint = 'https://' + e.apiEndpoint),
              (i.bootstrap = function () {
                var t,
                  i = document.createElement('script')
                ;((i.async = !0),
                  (i.type = 'text/javascript'),
                  (i.id = '__radar__'),
                  i.setAttribute('data-settings', JSON.stringify(e)),
                  (i.src = [
                    -1 !== (t = e.cdn).indexOf('http') ? '' : 'https://',
                    t,
                    '/releases/latest/radar.min.js',
                  ].join('')))
                var a = document.scripts[0]
                a.parentNode.insertBefore(i, a)
              }),
              i.bootstrap())
          }
      } else
        'undefined' != typeof console &&
          console.error('[Radar] Configuration incomplete')
    })({
      apiEndpoint: 'green-bicycle.geticonjar.com',
      cdn: 'green-bicycle.geticonjar.com',
      namespace: 'Snitcher',
      profileId: '8434592',
    })
  }
}
